import React from "react";
import CustomEvent from "custom-event";
import { SuburbModel } from "../../models/SuburbModel";
import PostcodeField from "./PostcodeField";
import TagManager from "react-gtm-module";

interface State {
  isVisible: boolean;
  suburb: SuburbModel;
  preSelectedSuburb: SuburbModel;
}

interface Props {
  content: any;
}

class PostcodeModal extends React.PureComponent<Props, State> {
  postcodeField: PostcodeField = null;

  constructor(props: Props) {
    super(props);

    this.state = {
      isVisible: false,
      suburb: null,
      preSelectedSuburb: null,
    };
  }

  componentDidMount(): void {
    window.addEventListener("selectLocation", () => this.show());
    document.addEventListener("keydown", (e) => this.handleKeyDown(e));
  }

  handleKeyDown(e): void {
    if (this.state.isVisible && e.keyCode === 27) {
      this.close(true);
    }
  }

  show(): void {
    this.setState({ isVisible: true });
    this.postcodeField.setFocus();
    //GTM event - on modal load
    TagManager.dataLayer({
      dataLayer: {
        event_id: "enter_post_code_pageview",
        event: "sd-pageview",
      },
    });
  }

  close(isCancelled: boolean = true): void {
    this.setState({ isVisible: false });

    if (isCancelled) {
      const evt: CustomEvent = new CustomEvent("locationSelectCancelled", {
        detail: { suburb: this.state.suburb, isRestored: false },
      });
      window.dispatchEvent(evt);
    }
  }

  onSuburbSelected(suburb: SuburbModel, isRestored: boolean): void {
    this.setState({ suburb });
    const evt: CustomEvent = new CustomEvent("locationSelected", {
      detail: { suburb: suburb, isRestored },
    });
    window.dispatchEvent(evt);

    if (!isRestored) {
      const megaNavEvt: CustomEvent = new CustomEvent("outsidePostCodeChange", {
        detail: { 
          name: suburb.name, 
          value: suburb.postcode, 
          label: `${suburb.name}, ${suburb.state} ${suburb.postcode}`
        }
      });
      window.dispatchEvent(megaNavEvt);
    }

    this.close(false);
  }

  onSuburbPreSelected(suburb: SuburbModel): void {
    this.setState({ preSelectedSuburb: suburb });
    const evt: CustomEvent = new CustomEvent("locationPreSelected", {
      detail: { suburb: suburb },
    });
    window.dispatchEvent(evt);
  }

  render() {
    const { isVisible, suburb, preSelectedSuburb } = this.state;
    const { title, copy, btnText, label } = this.props.content;

    return (
      <section className={`pc ${isVisible ? "pc__visible" : ""}`}>
        <div className="pc__overlay" onClick={() => this.close()} />
        <div className="pc__content">
          <div className="pc__close" onClick={() => this.close()} />
          <h4 className="pc__title">{title}</h4>
          <div className="pc__copy" dangerouslySetInnerHTML={{ __html: copy }} />
          <div className="pc__form">
            {label && <div className="pc__label">{label}</div>}
            <form
              className="pc__lookup"
              onSubmit={(e) => {
                e.preventDefault();
                this.postcodeField.formSubmit();
              }}
            >
              <PostcodeField
                ref={(instance) => {
                  this.postcodeField = instance;
                }}
                placeholder="Enter postcode"
                onSelected={(suburb, isRestored) => this.onSuburbSelected(suburb, isRestored)}
                onPreSelect={(suburb) => {
                  this.onSuburbPreSelected(suburb);
                }}
              />
            </form>

            <div
              id="viewDealerButton"
              className={`btn ${preSelectedSuburb ? "" : "btn--disabled"}`}
              onClick={(e) => preSelectedSuburb && this.postcodeField.formSubmit()}
            >
              {btnText}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PostcodeModal;
